import { render, staticRenderFns } from "./TiposProductoPantalla.vue?vue&type=template&id=3d801b10&"
import script from "./TiposProductoPantalla.vue?vue&type=script&lang=ts&"
export * from "./TiposProductoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports